import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import complaints from './ComplaintsData';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ImageModal from './ImageModal';
import PhotoRenderer from './PhotoRenderer'; // Импорт компонента
import '../css/ComplaintDetail.css';

const ComplaintDetail = () => {
  const { id } = useParams();
  const complaint = complaints.find((c) => c.id === id);
  const [modalImage, setModalImage] = useState(null); // Track the clicked image

  const handleImageClick = (src) => {
    setModalImage(src);
  };

  if (!complaint) {
    return <div>Complaint not found</div>;
  }

  return (
    <div className="complaint-detail">
      <div className="markdown-content">
        <h1>{complaint.title}</h1>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            img: ({ src, alt }) => (
              <img
                src={src}
                alt={alt}
                className="markdown-image"
                onClick={() => handleImageClick(src)}
              />
            ),
          }}
        >
          {complaint.description}
        </ReactMarkdown>
        {complaint.photos && (
          <div className="photos-preview">
            {complaint.photos.map((photo, index) => (
              <PhotoRenderer
                key={index}
                photo={photo}
                onClick={handleImageClick}
              />
            ))}
          </div>
        )}
        {complaint.files && complaint.files.length > 0 && (
          <div className="attached-files-section">
            <h2 className="attached-files-header">Attached Files</h2>
            <ul className="file-list">
              {complaint.files.map((file, index) => {
                const fileName = file.split('/').pop();
                return (
                  <li key={index}>
                    <a href={file} download>
                      {fileName}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
      {modalImage && <ImageModal src={modalImage} onClose={() => setModalImage(null)} />}
    </div>
  );
};

export default ComplaintDetail;
